import { Modal, Table } from "antd"
import { TablePaginationConfig } from "antd/lib/table/interface"
import { observer } from "mobx-react"
import * as React from "react"
import { useEffect, useState } from "react"
import { UtmTierEdit } from "../TiersEdit"
import { UtmTier } from "domains/utm/store"
import { useStore } from "stores/utils/use-store"
import { utmTierColumns } from "./columns"
import { Column } from "abstract/types/column.type"
import { DeleteIconButton, showDeleteConfirm, CreateNewElement } from "components"

export const AffiliateTiersList: React.FunctionComponent = observer(() => {
  const { dataStore: { utmTiersStore } } = useStore()

  const paginationOptions: TablePaginationConfig = {
    onChange: async page => {
      utmTiersStore.pagination.page = page
    },
    total: utmTiersStore.total,
    showTotal: (total, range) => `${range[0]} to ${range[1]} of ${total}`,
    defaultPageSize: 10,
  }

  const [isVisibleEditCreate, setEditCreateVisibility] = useState<"create" | "edit" | null>(null)

  useEffect(() => {
    utmTiersStore.getData()
  }, [utmTiersStore])

  const onClose = () => {
    utmTiersStore.clearSelectedElement()
    setEditCreateVisibility(null)
  }

  const columns: Column[] = [
    ...utmTierColumns,

    {
      title: "Delete",
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (_: any, row: any) => (
        <DeleteIconButton
          onClick={e => {
            e.stopPropagation()
            showDeleteConfirm(`market item: ${row.name}`, undefined, async() => {
              utmTiersStore.funcAfterSuccess = async() => await utmTiersStore.getData()

              utmTiersStore.delete(row.id)
            })
          }}
        />
      ),
    },
  ]

  return (
    <>
      <CreateNewElement onClick={() => setEditCreateVisibility("create")} valueText="utm tier" />
      <Table
        dataSource={utmTiersStore.utmTiers}
        columns={columns as any}
        rowKey="id"
        pagination={paginationOptions}
        loading={utmTiersStore.isLoading}
        onRow={(record: UtmTier) => ({
          onClick: () => {
            utmTiersStore.selectedElement = record
            setEditCreateVisibility("edit")
          },
        })}
      />

      {isVisibleEditCreate && (
        <Modal
          visible
          title={isVisibleEditCreate === "edit" ? "Edit utm tier" : "Create utm tier"}
          width="700px"
          footer={null}
          onCancel={onClose}
          style={{ top: "10px" }}
        >
          <UtmTierEdit editType={isVisibleEditCreate} onClose={onClose} />
        </Modal>
      )}
    </>
  )
})
